<app-main>
  <ng-container>
    <div class="results-info">
      <h1 class="results-title">Átirányítás...</h1>
    </div>
  </ng-container>
</app-main>
